import Vue from 'vue'

import ShopGroup from './ShopGroup'
import ShopPage from './ShopPage'
import ShopTag from './ShopTag'
import Prices from './Product/Prices'
import RelatedProducts from './Product/RelatedProducts'
import ShopSearchResults from './Search/ShopSearchResults'
import Cart from './cart/Cart';
import CartNavbar from './cart/CartNavbar'
import HomeTags from './HomeTags'
import ShopSDTransformerPage from './ShopSDTransformerPage'

Vue.component('shop-group', ShopGroup);
Vue.component('shop-page', ShopPage);
Vue.component('shop-tag', ShopTag);
Vue.component('prices', Prices);
Vue.component('related-products', RelatedProducts);
Vue.component('shop-search-results', ShopSearchResults);
Vue.component('cart', Cart);
Vue.component('cart-navbar', CartNavbar);
Vue.component('home-tags', HomeTags);
Vue.component('shop-sd-transformer-page', ShopSDTransformerPage);



// WEBPACK FOOTER //
// ./components/shop/index.js